/* eslint-disable array-callback-return */
/* eslint-disable indent */
import React, { Fragment } from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import Select from "react-select";

import TextInput2 from "../../component/input/TextInput2";
import SelectInput2 from "../../component/input/SelectInput2";
import Button from "../../component/button/Button";
import { topInputToolTipData, options } from "./userData";
import {
  isSuperAdmin,
  locationRender,
  renderAccessLocation2,
  renderLocationFunction
} from "../../constant/helper/helper";

const TopInput = ({
  values,
  onChange,
  department,
  currentUser,
  allLocations,
  statusOfUser,
  onLoadMoreClick,
  selectedValues,
  handleSelectCategories,
  getAllWorkersBySpecificInputs
}) => {
  const toolTipRender = () => {
    return topInputToolTipData.map((tipData, index) => (
      <Fragment key={index}>
        <ReactTooltip
          place="top"
          type="info"
          effect="solid"
          id={tipData.id}
        >
          {tipData.text}
        </ReactTooltip>
      </Fragment>
    ));
  };

  return (
    <Fragment>
      <div className="row">
        {toolTipRender()}
        <div className="col-lg-3 col-md-3 col-sm-12">
          <SelectInput2
            data-tip
            isLabeled={true}
            name="locationId"
            onChange={onChange}
            data-for="locationId"
            label="Select Location"
            value={values.locationId}
            placeholder="Select Location"
            icon="mdi mdi-map-marker-radius"
          >
            {isSuperAdmin(currentUser)
              ? renderLocationFunction(allLocations)
              : renderAccessLocation2(
                  locationRender(currentUser, false)
                )}
          </SelectInput2>
        </div>
        <div className="col-lg-3 col-md-3 col-sm-12">
          <SelectInput2
            data-tip
            isLabeled={true}
            onChange={onChange}
            name="userDepartment"
            data-for="userDepartment"
            label="Select Department"
            icon="mdi mdi-playlist-check"
            value={values.userDepartment}
            placeholder="Select Department"
          >
            <option value="ALL">ALL</option>
            {department.map((data, index) => (
              <option value={data._id} key={index}>
                {data.departmentName}
              </option>
            ))}
          </SelectInput2>
        </div>
        <div className="col-lg-6">
          <Select
            isMulti
            name="categories"
            options={options}
            classNamePrefix="select"
            defaultValue={selectedValues}
            className="basic-multi-select"
            placeholder={"Select More Filters And Get Data"}
            onChange={handleSelectCategories}
          />
        </div>
      </div>
      <div className="row">
        {toolTipRender()}
        <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
          <SelectInput2
            data-tip
            isLabeled={true}
            name="activeStatus"
            onChange={onChange}
            label="Select Type"
            data-for="activeStatus"
            placeholder="Select Type"
            value={values.activeStatus}
            icon="mdi mdi-playlist-check"
          >
            <option value={true}>Active</option>
            <option value={false}>De-Active</option>
          </SelectInput2>
        </div>
        <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
          <TextInput2
            type="text"
            data-tip
            name="Filter"
            data-for="Filter"
            onChange={onChange}
            value={values.Filter}
            placeholder="Search..."
            icon="mdi mdi-table-search"
          />
        </div>

        <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
          <Button
            data-tip
            title="Get"
            type="button"
            data-for="get"
            isBackgroundColor={false}
            icon="mdi mdi-database-plus mr-2"
            onClick={getAllWorkersBySpecificInputs}
            className="btn text-black btn-block btn-warning"
          />
        </div>

        <div className="col-xl-3 col-lg-3 col-md-12 col-sm-12">
          <Button
            data-tip
            title="Load"
            type="button"
            data-for="loadMore"
            isBackgroundColor={false}
            onClick={onLoadMoreClick}
            icon="mdi mdi-database-plus mr-2"
            className="btn text-white btn-block btn-primary float-right"
          />
        </div>
      </div>
    </Fragment>
  );
};

TopInput.propTypes = {
  values: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  department: PropTypes.array.isRequired,
  currentUser: PropTypes.object.isRequired,
  allLocations: PropTypes.array.isRequired,
  statusOfUser: PropTypes.object.isRequired,
  onLoadMoreClick: PropTypes.func.isRequired,
  selectedValues: PropTypes.array.isRequired,
  handleSelectCategories: PropTypes.func.isRequired,
  getAllWorkersBySpecificInputs: PropTypes.func.isRequired
};

export default TopInput;
